import '.aw{position:relative;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.hd{min-height:200px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.a3{justify-content:center;}.ssr-plugin'
import '.av{align-items:flex-start;}.ssr-plugin'
import '.dc{padding:2rem;}.ssr-plugin'
import '.dj{background:var(--palette-white);}.ssr-plugin'
import '.al{overflow:hidden;}.ssr-plugin'
import '.c8{position:absolute;}.ssr-plugin'
import '.jn{top:50%;}.ssr-plugin'
import '.jo{right:1rem;}.ssr-plugin'
import '.jp{transform:translateY(-50%);}.ssr-plugin'
import '.jq{width:120px;}.ssr-plugin'
import '.jr{height:120px;}.ssr-plugin'
import '.js{z-index:0;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.iq{z-index:1;}.ssr-plugin'
import '.s{gap:0.5rem;}.ssr-plugin'
import '.jt{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="aw n hd d e a3 av dc dj al"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="c8 jn jo jp jq jr js d r a3"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="aw iq d e av s jt"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--brand-secondary)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--brand-secondary)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
